// extracted by mini-css-extract-plugin
export default {"button":"learningStatus_button__CEshg","buttonLearned":"learningStatus_buttonLearned__X7fEa","buttonLink":"learningStatus_buttonLink__zaNyI","badge":"learningStatus_badge__SM5Sh"};